import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IOption } from '../models/option';

export interface ITab {
  label: string;
  id: string;
}

@Component({
    selector: 'app-tab',
    templateUrl: './tab.component.html',
    styleUrl: './tab.component.scss',
    standalone: false
})
export class TabComponent implements OnInit {
  private _tabs: ITab[] = [];

  @Input()
  set tabs(value: ITab[]) {
    this._tabs = value ?? [];
    this.tabAsOptions = this._tabs.map(tab => ({ label: tab.label, value: tab.id }));
  }
  get tabs(): ITab[] {
    return this._tabs;
  }

  @Input() initialTabId: string | null = null;
  @Input() id: string = 'app-tab';
  @Output() onTabChange = new EventEmitter<string>();

  selectedTab: string = '';
  tabAsOptions: IOption<string>[] = [];

  ngOnInit(): void {
    this.tabAsOptions = this.tabs?.map(tab => ({ label: tab.label, value: tab.id })) ?? [];

    if (this.initialTabId && this.initialTabId.trim().length > 0) {
      const tab = this.tabs.find(tab => tab.id === this.initialTabId);
      if (tab) {
        this.onSelectTabClickEvent(tab);
        return;
      }
    }

    if (this.tabs.length > 0) {
      this.onSelectTabClickEvent(this.tabs[0]);
    }
  }

  onSelectTabClickEvent(tab: ITab): void {
    this.selectedTab = tab.id;
    this.onTabChange.emit(tab.id);
  }

  onSelectedTabDropdownChangeEvent(): void {
    this.onTabChange.emit(this.selectedTab);
  }
}
